import { IconSearch } from '@/blocks/components/Icons';
import typography from '@/styles/typography.module.scss';

export function NoOptions(props: React.PropsWithChildren<{}>) {
  return (
    <div>
      <IconSearch />
      <div className={typography.bodyM}>{props.children}</div>
    </div>
  );
}
